import React, { memo } from 'react';

import styles from './styles';

export interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  stroke?: number;
}

const LoadingSpinner = (props: LoadingSpinnerProps) => {
  const { size = 16, color, stroke = 2 } = props;

  const style = {
    '--tui-loader-stroke': `${stroke}px`,
    '--tui-loader-size': `${size}px`,
  } as React.CSSProperties;

  return (
    <svg
      className={styles.loader}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      height={size}
      color={color}
      style={style}
    >
      <circle
        className={styles.spinner}
        cx="50%"
        cy="50%"
        r="50%"
        fill="none"
        stroke="currentColor"
      />
    </svg>
  );
};

export default memo(LoadingSpinner);
